import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
// import { Link } from 'react-router-dom';
import { Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';

import SaleBanner from '../../static/img/sales/2024CDSale.png';
// import SaleBanner from '../../static/img/sales/black_friday_2022/nia_black_friday_hero.gif';
import MemorialDaySaleBanner from '../../static/img/sales/memorial_day_2024/memorial_day_2024_banner.jpg';
import memorialDaySale2024Data from '../../static/memorial_day_sale_2024_data';

// Sale Section with simple banner IMG
const styles = theme => ({
  section: {
    width: '100%',
    backgroundColor: '#EEEEEE',
    position: 'relative',
    margin: '0 auto',
  },
  content: {
    width: '100%',
    [theme.breakpoints.up(900)]: {
      width: '900px',
      marginBottom: '200px',
    },
    margin: '0 auto',
    height: '300px',
  },
  img: {
    height: 'auto',
    width: '100%',
  },
  spacer: {
    height: theme.spacing(10),
  },
});

const unstyledSaleSection = (props) => {
  const { classes } = props;
  return (
    <div className={classes.section}>
      <div className={classes.spacer} />
      <div className={classes.content}>
        <Grid container>
          <a href="/shop/music">
            <img src={SaleBanner} className={classes.img} alt="sale banner" />
          </a>
        </Grid>
      </div>
      <div className={classes.spacer} />
    </div>
  );
};

unstyledSaleSection.propTypes = {
  classes: PropTypes.object.isRequired,
};

const SaleSection = withStyles(styles)(unstyledSaleSection);

// Memorial Day 2024 Sale Section
const memorialDaySaleStyles = theme => ({
  section: {
    width: '100%',
    backgroundColor: '#EEEEEE',
    position: 'relative',
    margin: '0 auto',
  },
  content: {
    width: '100%',
    [theme.breakpoints.up(900)]: {
      width: '95%',
      margin: '0 auto',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2),
    },
    marginBottom: theme.spacing(2),
    maxWidth: '1300px',

  },
  img: {
    height: 'auto',
    width: '100%',
    [theme.breakpoints.up(900)]: {
      borderRadius: '20px',
    },
  },
  spacer: {
    height: theme.spacing(4),
  },
  copyGrid: {
    padding: '20px',
  },
  buttonContainer: {
    textAlign: 'center',
    width: '100%',
  },
  header: {
    color: '#f63c57',
    fontSize: '2.5rem',
    [theme.breakpoints.down(500)]: {
      fontSize: theme.typography.pxToRem(30),
    },
  },
  copy: {

  },
  button: {
    color: 'white',
    backgroundColor: '#f63c57',
    '&:hover': {
      backgroundColor: '#f52443',
    },
    fontSize: '24px',
  },
  link: {
    textDecoration: 'none',
    color: 'blue',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
});
const unstylyedMemorialDay2024SaleSection = (props) => {
  const { classes } = props;
  return (
    <div className={classes.section}>
      <div className={classes.spacer} />
      <div className={classes.content}>
        <Grid container direction='row-reverse'>
          <Grid item sm={12} md={6}>
            <a href="/sale">
              <img src={MemorialDaySaleBanner} className={classes.img} alt="Memorial day sale banner" />
            </a>
          </Grid>
          <Grid className={classes.copyGrid} item sm={12} md={6}>
            <Typography variant="h6" color="secondary" allign="center">
              <span className={classes.header}>{memorialDaySale2024Data.header}</span>
              <span>{memorialDaySale2024Data.copy}</span>
              <a className={classes.link} href="https://niaondemand.com/" target="_blank" rel="noopener noreferrer">Nia On Demand</a>
              <span>{memorialDaySale2024Data.copy2}</span>
            </Typography>
            <div className={classes.buttonContainer}>
              <Button color="secondary" variant="outlined" size="large" href="/sale" className={classes.button}>Find out more</Button>
            </div>
          </Grid>
        </Grid>
      </div>
      <div className={classes.spacer} />
    </div>
  );
};

unstylyedMemorialDay2024SaleSection.propTypes = {
  classes: PropTypes.object.isRequired,
};

const MemorialDay2024SaleSection = withStyles(memorialDaySaleStyles)(unstylyedMemorialDay2024SaleSection);

export {
  SaleSection,
  MemorialDay2024SaleSection,
};
